// extracted by css-extract-rspack-plugin
export default {"link":"_4eb107c7"};